import Head from "next/head";
import PropTypes from "prop-types";
import React from "react";

const MetaData = ({ metaData }) => {
  const {
    allowSearchEngineIndex = true,
    description,
    image,
    keywords,
    title = "Equinox",
    url,
  } = metaData;

  return (
    <Head>
      <title>{title}</title>
      {description && <meta content={description} name="description" />}
      {keywords && <meta content={keywords} name="keywords" />}
      {image && (
        <meta
          content={image && `https:${image.fields.file.url}`}
          property="og:image"
        />
      )}
      {url && <meta content={url} property="og:url" />}
      <meta content="summary_large_image" name="twitter:card" />
      <meta content="@Equinox" name="twitter:site" />
      <meta
        content={allowSearchEngineIndex ? "index, follow" : "noindex, nofollow"}
        name="robots"
      />
      {url && <link href={url} rel="canonical" />}
    </Head>
  );
};

MetaData.propTypes = {
  metaData: PropTypes.shape({
    allowSearchEngineIndex: PropTypes.bool, // eslint-disable-line react/boolean-prop-naming
    description: PropTypes.string,
    image: PropTypes.shape({
      fields: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    keywords: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default MetaData;
